export function formatDate(rowData, column) {
  if (!rowData[column.field]) return ''

  var d = convertDateToUTC(new Date(rowData[column.field]))

  var finalDateTime = `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d
    .getDate()
    .toString()
    .padStart(2, '0')}/${d.getFullYear().toString().padStart(4, '0')} ${d
    .getHours()
    .toString()
    .padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`

  return finalDateTime.replace(' 00:00:00', '')
}

function convertDateToUTC(date) {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  )
}

export function formatDateDirect(date) {
  if (!date) return ''

  var d = convertDateToUTC(new Date(date))

  var finalDateTime = `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d
    .getDate()
    .toString()
    .padStart(2, '0')}/${d.getFullYear().toString().padStart(4, '0')}`

  return finalDateTime.replace(' 00:00:00', '')
}

export const formatDateToUserTimezone = (date, user, options = {}) => {
  if (!date || !user) return ''

  const d = new Date(date)

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: user?.timezone || 'America/Chicago',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: options.hour12 || true,
  })

  return formatter.format(d)
}
